// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 203) return "static/chunks/e3762d72-ee78ba5b245f9ffa.js";
	if (chunkId === 379) return "static/chunks/379-c6eda8194a82d268.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"9167eeea64bf5c30","205":"2e90144ef4045da8","319":"0cbc2894a3f1b950","340":"0417d9ab8f049ab5","367":"6c2897a57d4ca56d","639":"e7b660adfa99260e","748":"53905b7e8b9e9f02"}[chunkId] + ".js";
};